// Inbound OIDC SSO — kick off the login redirect from the email the user typed.
// Posts to the public oidc_initiate endpoint (no auth token — pre-login) and returns
// the IdP authorize URL to redirect the browser to. The IdP later redirects back to
// oidc_callback, which hands off to the app via ?ssoAccessToken (useSsoLogin).
import axios from "axios";

export async function initiateSso(email: string): Promise<string> {
    const res = await axios({
        method: "POST",
        baseURL: process.env.REACT_APP_API_URL,
        url: "t11/v1/oidc_initiate",
        json: true,
        data: {Email: email, AppUrl: window.location.origin},
    } as any);
    const authorizeUrl = res.data?.authorize_url;
    if (!authorizeUrl) {
        throw new Error("SSO is not configured for this email domain.");
    }
    return authorizeUrl as string;
}
